module.exports = __webpack_public_path__ + "img/serpant.0a74986b.png";